import axios from "axios";
import {getSessionData} from "./index";

const axiosInstance = axios.create();

// Add session data to headers
axiosInstance.interceptors.request.use(
  (config) => {
    // `getSessionData` might still be undefined the first few milliseconds
    const session = typeof getSessionData === "function" ? getSessionData() : undefined;

    if (session && session.device_info) {
      const d = session.device_info;
      const g = session.geographic_location || {};

      config.headers = {
        ...config.headers,
        "X-Session-Id": session.session_id,
        "X-Device-Id": session.device_id,
        "X-UTM-Source": session.utm_source,
        "X-UTM-Campaign": session.utm_campaign,
        "X-UTM-Medium": session.utm_medium,
        "X-Page-Url": session.page_url,

        "X-Operating-System": d.os || "Unknown",
        "X-OS-Version": d.os_version || "Unknown",
        "X-Browser-Type": d.browser || "Unknown",
        "X-Browser-Version": d.browser_version || "Unknown",
        "X-Device-Type": d.device || "Unknown",
        "X-Device-Model": d.device_model || "Unknown",

        "X-Country": g.country || "Unknown",
        "X-Region": g.region || "Unknown",
        "X-City": g.city || "Unknown",
      };
    }

    // console.log("Request headers:", config.headers);
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
